module.exports = __webpack_public_path__ + "static/media/logo-icon.a5db1405.svg";